import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// GET subscriber/getFuturePlanList/{custId} -> dataList
export const futurePlanList = createAsyncThunk('futurePlan/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getFuturePlanList/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const futurePlan = createSlice({
    name: 'futurePlan',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(futurePlanList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(futurePlanList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(futurePlanList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export default futurePlan.reducer;
